import localhost, { downloadFileFromResponse } from "apis/localhost";
import { alertVariants } from "@visiblethread/react-components/dist/components/Alert";
import { modalTypes } from "constants/types";
import { getErrorMessage } from "utils";
import {
  addToJobQueue,
  clearJobQueue,
  showGlobalAlert,
  showInlineAlert,
} from "slices/app/appSlice";
import { hideModal } from "slices/app/actions/modals";
import { showErrorModal } from "slices/app/actions/error";

export const downloadWorkbook =
  (template = false) =>
  async (dispatch) => {
    dispatch(addToJobQueue("genericJob"));

    await localhost
      .get("/docs/macros/", { params: { template }, responseType: "blob" })
      .then((response) => {
        const { data } = response;
        const title = response.headers["content-disposition"].split('"')[1];
        downloadFileFromResponse(data, title);
        dispatch(clearJobQueue());
      })
      .catch((error) => {
        dispatch(hideModal(modalTypes.IMPORT_FILE));
        dispatch(showErrorModal(error));
      })
      .finally(() => {
        dispatch(clearJobQueue());
      });
  };

export const uploadWorkbook = (formData) => async (dispatch) => {
  dispatch(addToJobQueue("genericJob"));

  await localhost
    .post("/docs/macros/", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    })
    .then(() => {
      dispatch(
        showInlineAlert({
          variant: alertVariants.success,
          text: "Macro Enabled Workbook Uploaded",
        })
      );
    })
    .catch((error) => {
      dispatch(
        showGlobalAlert({
          variant: alertVariants.danger,
          text: getErrorMessage(error),
        })
      );
    })
    .finally(() => {
      dispatch(hideModal(modalTypes.IMPORT_FILE));
      dispatch(clearJobQueue());
    });
};
